import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  GenericLinkDirective,
  PhoneFilterPipe,
  UrlTargetPipe,
} from '@boels/helpers';
import { CmsComponentData, ContactDetailsComponentData } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faFacebook,
  faSquareTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { GenericLinkComponent } from '../generic-link/generic-link.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'boels-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    GenericLinkComponent,
    TranslocoModule,
    UrlTargetPipe,
    PhoneFilterPipe,
    ButtonComponent,
    GenericLinkDirective,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['contact'],
    },
  ],
})
export class ContactDetailsComponent implements OnInit {
  private router = inject(Router);

  @Input() componentData: CmsComponentData<ContactDetailsComponentData>;

  faPhone = faPhone;
  faFacebook = faFacebook;
  faTwitter = faSquareTwitter;
  faEnvelope = faEnvelope;

  isContactPage: boolean;

  ngOnInit(): void {
    this.isContactPage =
      this.router.routerState.snapshot.url.indexOf('contact') !== -1;
  }
}
